// extracted by mini-css-extract-plugin
export default {"container":"CommentsCounter_container__CEMdy"};